module.exports = __webpack_public_path__ + "img/fallback.bec61a7c.svg";